import React from "react";
import { EmojiDisplayContainer } from "../comp/EmojiDisplayContainer";
import { Icon } from "../comp/Icon";
import {editName} from "../_global";

export class LoadDisplay extends React.Component {
    constructor(props) {
        super(props);

        this.load = this.load.bind(this);
        this.remove = this.remove.bind(this);
        this.rename = this.rename.bind(this);
    }

    load() {
        this.props.load(this.props.data.layers);
    }

    remove() {
        this.props.remove(this.props.index);
    }

    rename() {
        // rename save
        var name = window.prompt("Enter a new name:", this.props.data.name);

        if(name != "" && name != null) {
            editName(this.props.index, name);
            this.props.refresh();
        }
    }


    render() {
        return (
            <div className="saved-emoji" key={this.props.index}>
                <div className="buttons">
                    <button className="give-tooltip" data-tooltip="Remove" onClick={this.remove}> <Icon type="fa-remove" /> </button>
                    <button className="give-tooltip" data-tooltip="Edit name" onClick={this.rename}> <Icon type="fa-pencil" /> </button>
                    <button className="give-tooltip" data-tooltip="Load" onClick={this.load}> <Icon type="fa-arrow-up" /> </button>
                </div>

                <EmojiDisplayContainer layers={this.props.data.layers} select={this.props.select} />

                <span className="label">{this.props.data.name}</span>
            </div>
        );
    }
}
